import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../http-error-handler.service';

import { Config } from '../config';
import { DewAuthService } from 'src/authentication/core/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiMasterClientService {
  private handleError: HandleError;

  private httpOptions = null;
  constructor(
    private http: HttpClient,
    private authService: DewAuthService,
    httpErrorHandler: HttpErrorHandler,
    private sanitizer: DomSanitizer
  ) {
    this.handleError = httpErrorHandler.createHandleError('ApiService');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.authService.authToken,
      }),
    };
  }

  getAllmasterClient(gridProperties, status): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getAllmasterClient';
    var request: any = {};
    request.gridProperties = gridProperties;
    request.status = status;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getAllmasterClient', request)));
  }

  getmasterClientById(masterClientGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getmasterClientById';
    var request: any = {};
    request.masterClientGetId = masterClientGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getmasterClientById', request)));
  }

  insertMasterClient(masterClientDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/createmasterClient';
    var request: any = {};
    request = masterClientDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('createmasterClient', request)));
  }

  updateMasterClient(masterClientDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updatemasterClientBymasterClientId';
    var request: any = {};
    request = masterClientDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('updatemasterClientBymasterClientId', request))
      );
  }
  
  updatemasterClientStatus(masterClientDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updatemasterClientStatusById';
    var request: any = {};
    request = masterClientDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('updatemasterClientStatusById', request))
      );
  }

  getMasterClientShiftbyId(masterClientGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getMasterClientShiftbyId';
    var request: any = {};
    request.masterClientGetId = masterClientGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getMasterClientShiftbyId', request)));
  }

  insertMasterClientShift(masterClientDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/createMasterClientShift';
    var request: any = {};
    request = masterClientDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('createMasterClientShift', request)));
  }

  updateMasterClientShiftById(ShiftDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updateMasterClientShiftById';
    var request: any = {};
    request = ShiftDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('updateMasterClientShiftById', request))
      );
  }

  getMasterClientTimeOffbyId(masterClientGetId, status): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getmasterClientTimeOffbyId';
    var request: any = {};
    request.masterClientGetId = masterClientGetId;
    request.status = status;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getmasterClientTimeOffbyId', request)));
  }

  insertMasterClientTimeOff(masterClientDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/createmasterClientTimeOff';
    var request: any = {};
    request = masterClientDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('createmasterClientTimeOff', request)));
  }

  updateMasterClientTimeOffById(ShiftDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updatemasterClientTimeOffById';
    var request: any = {};
    request = ShiftDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('updatemasterClientTimeOffById', request))
      );
  }

  updatemasterClientTimeOffStatus(ShiftDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updatemasterClientTimeOffStatus';
    var request: any = {};
    request = ShiftDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('updatemasterClientTimeOffById', request))
      );
  }
  
}
